// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__31gb3","head":"ProcedureTableInfo_head__KjwTK"};